export const NAME = 'b2bActivation';
